import {
    fetchGetPaymentMethod,
    GetPaymentMethodResponse
} from '@iwoca/lapi-client/edge';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { useStateKey } from '../../iwQueryClient/useStateKey';

type TUseGetPaymentMethodOptions<TData> = Omit<
    UseQueryOptions<GetPaymentMethodResponse, unknown, TData>,
    'queryKey' | 'queryFn'
>;

// Shared reader for the customer's payment methods. Callers pass `select` to
// shape the response and `suspense` to opt into Suspense.
export function useGetPaymentMethod<TData = GetPaymentMethodResponse>(
    options: TUseGetPaymentMethodOptions<TData> = {}
) {
    const stateKey = useStateKey();

    return useQuery<GetPaymentMethodResponse, unknown, TData>({
        queryKey: ['fetchGetPaymentMethod', stateKey],
        queryFn: () => fetchGetPaymentMethod({ stateKey }),
        ...options
    });
}
